export default __webpack_public_path__ + "static/Letter_of_Recommendation-90e3161ecfa86e51be3fc7e5c278cfd0.pdf";